import React, { Component } from "react";
import { connect } from "react-redux";
import FlatButton from "material-ui/FlatButton";
import { Field, reduxForm } from "redux-form";
import TextField from "material-ui/TextField";
import { Flex, Box } from "rebass";
import styled from "styled-components";
import { showNotification as showNotificationAction } from "admin-on-rest";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import { RestApiRequestCommission } from "../../restClient";
import { ValuesForm } from "../../components/form/ValuesForm";
import Dialog from "material-ui/Dialog";
import { checkNumber } from "../utilsMarketer";
import { CubeGrid } from "../../components/spinkit";
import { cyan500 } from "material-ui/styles/colors";

const validate = values => {
  const errors = {};
  const requiredFields = ["type", "amount"];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  return errors;
};

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    hintText={label}
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    {...custom}
  />
);

const renderRadioGroup = ({ input, ...rest, meta: { touched, error } }) => (
  <Box w={[1]}>
    <RadioButtonGroup
      {...input}
      {...rest}
      valueSelected={input.value}
      onChange={(event, value) => input.onChange(value)}
      style={{ display: "flex", flex: 1, flexDirection: "row" }}
    />
      {touched && error && <BoxMessage>{error}</BoxMessage>}
  </Box>
);

class FormRequestCommission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showButtonAdjust: false,
      isLoading: false,
    };
  }
  
  onSubmit = values => {
    const { params } = this.props.match
    if(params && params.id){
      this.setState({
        isLoading: true
      })
      
    RestApiRequestCommission(params.id , values)
      .then(response => {
        if (response.status >= 400) {
          this.setState({
            isLoading: false,
          });
          this.props.showNotification("Bad Response", "warning");
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (data.message !== undefined) {
          this.setState({
            isLoading: false,
            
          });
          this.props.showNotification(data.message, "warning");
        } else {
          this.setState({
            isLoading: false,
            
          });
          this.props.showNotification("Adjust commission successful");
          this.props.handleClose("success");
          this.props.reset()
        }
      })
      .catch(e => {
        this.setState({
          isLoading: false
        });
        this.props.showNotification("Please try again", "warning");
        //console.error(e);
      });
    }
    
    
  };

  
  render() {
    const { handleSubmit,  submitting } = this.props;

    return (
      <div>
        <Dialog title="Adjust Commission" modal={true} open={this.props.open}>
          <form
            onSubmit={handleSubmit(this.onSubmit.bind(this))}
            className="simple-form"
          >
            <Box pt={[3]} w={[1]}>
              <Flex w={[1]} direction={["row"]}>
                <Field name="type" component={renderRadioGroup}>
                  <RadioButton
                    value="BOS"
                    label="Bonus"
                    style={{ width: 150 }}
                  />
                  <RadioButton value="COM" label="Commission" />
                </Field>
              </Flex>
              <div>
                <Field
                  name="amount"
                  component={renderTextField}
                  label="Amount"
                  type="number"
                  parse={v => checkNumber(v)}
                />
              </div>
              <div>
                <Field
                  name="description"
                  component={renderTextField}
                  label="Description"
                  fullWidth={true}
                />
              </div>
              {this.state.isLoading && <Box w={[1]} p={[2]} mb={[2]} justify={["center"]} align={["center"]}>
                <CubeGrid size={30} color={cyan500} />
              </Box>}
            </Box>
            
            <Flex w={[1]} pt={[2]} direction={["row"]} justify={["flex-end"]}>
              <FlatButton
                label="Cancel"
                primary={true}
                onClick={()=>this.props.handleClose("default")}
              />
              <FlatButton
                type="submit"
                label="Submit"
                disabled={submitting}
                primary={true}
              />
            </Flex>
          </form>
        </Dialog>
        <ValuesForm isDebug={false} formName={"requestCommissionForm"} />
      </div>
    );
  }
}

const BoxMessage = styled.div`
  position: relative;
  bottom: -5px;
  font-size: 12px;
  line-height: 24px;
  color: rgb(244, 67, 54);
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  border-top: 2px;
  border-top-color: rgb(244, 67, 54);
  border-top-width: 2px;
  border-top-style: solid;
`;

const formed = reduxForm({
  form: "requestCommissionForm",
  validate
})(FormRequestCommission);

const mapStateToProps = state => {
  var initialValues = {};

  return { initialValues, formState: state };
};

export default connect(mapStateToProps, { showNotification: showNotificationAction })(formed);


// WEBPACK FOOTER //
// ./src/marketers/form/FormRequestCommission.js